<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.slug">Edit</template><template v-else>New</template> Article</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitArticle()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Article</span><span v-if="saved">Article Saved</span></button>
        </div>
      </div>
      <div class="articleDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="article.title" placeholder="My New Blog Article" class="w3-input w3-border" />
              </div>
              <div class="input-row w3-padding-8">
                <label>Content</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="article.text"></tinymce-editor>
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header class="w3-left-align">Article SEO</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Meta Title</label>
                <input class="w3-input w3-border" v-model="article.metaTitle" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Meta Description</label>
                <input class="w3-input w3-border" v-model="article.metaDescription" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
            <header>Details</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Created</label>
                <input v-model="article.created" type="date" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Status</label>
                <div class="w3-right-align">
                  <label class="switch">
                    <input type="checkbox" v-model="article.status">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header>Image</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Image Alt Tag</label>
                <input v-model="imageAlt" placeholder="Image Description" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8" style="border-bottom:0;">
                <label style="margin-top:6px;">Image (550x412)</label>
                <div class="w3-right-align">
                  <label for="articleFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                  <input id="articleFile" type="file" @change="uploadArticleImage($event.target.files)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                </div>
              </div>
              <div class="w3-center w3-border-bottom w3-padding-bottom">
                <img v-if="article.image.src !== ''" :src="article.image.src" style="width:100%; max-width:300px;" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsnews',
  data() {
    return {
      state: dataStore.state,
      article: null,
      saving: false,
      saved: false,
      imageAlt: ''
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initArticle()
    this.article.created = new Date().toISOString().slice(0, 10)
    this.imageAlt = this.article.image.alt
    if (this.$route.params.slug) {
      for (let savedArticle of this.state.siteData.content.news.items) {
        if (this.$route.params.slug === savedArticle.url) {
          this.article = savedArticle
          break
        }
      }
    }
  },
  methods: {
    initArticle() {
      this.article = {
        title: '',
        text: '',
        image: {
          src: '',
          alt: ''
        },
        url: '',
        created: '',
        status: true
      }
    },
    uploadArticleImage(files) {
      dataStore.uploadImage(files).then((path) => {
        this.article.image.src = path
      })
    },
    saveContent() {
      this.article.url = slug(this.article.title)
      this.article.image.alt = this.imageAlt
      let loopIndex = 0
      let found = false
      for (let newsArticle of this.state.siteData.content.news.items) {
        if (newsArticle.url === this.article.url) {
          if (!confirm('URL exists, overwrite?')) {
            return
          } else {
            console.log(newsArticle)
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.content.news.items[loopIndex] = this.article
      } else {
        this.state.siteData.content.news.items.push(this.article)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace('/cms/news')
        }
      })
    },
    exitArticle() {
      this.initArticle()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .newsTitle {font-size:1rem;}
  .newsMeta {font-size:1rem; font-family: 'Roboto', sans-serif; text-align: center;}
  .newsGrid {display:grid; grid-template-columns: 225px 1fr; grid-gap: 8px; border-bottom: 1px solid #ccc;}
  .newsGrid:last-child {border-bottom:0;}
  .newsContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .articleDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
@media screen and (max-width:993px) {
  .newsTitle {font-size:10pt;}
  .newsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .newsGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
  .headerGridCMS {grid-template-columns: 1fr 1fr;}
  .articleDetailGrid {grid-template-columns: 1fr;}
  .cardRow {grid-template-columns: 1fr;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsNewsDetail.vue